import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SidebarComponent } from '../../sidebar.component';

export interface CustomizerOption {
  id: string | number;
  value: string;
  display_label: string;
  inputType: string;
  selectedValue?: string;
}

@Component({
  selector: 'app-customizer-sidebar',
  standalone: true,
  imports: [CommonModule, FormsModule, SidebarComponent],
  templateUrl: './customizer-sidebar.component.html',
  styleUrls: ['./customizer-sidebar.component.scss'],
})
export class CustomizerSidebarComponent {

  @Input() isOpen = false;
  @Input() image: string = '';
  @Input() options: CustomizerOption[] = [];

  @Output() close = new EventEmitter<void>();
  @Output() saveCustomization = new EventEmitter<Record<string, string>>();

  onClose() {
    this.close.emit();
  }

  save() {
    const data: Record<string, string> = {};
    for (const opt of this.options) {
      if (opt.selectedValue) {
        data[opt.value] = opt.selectedValue;
      }
    }
    this.saveCustomization.emit(data);
    this.onClose();
  }
}
